<template lang="pug">
  figure.ui-avatar.image
    img.is-rounded(:src="avatarSrc")
</template>

<script>
export default {
  name: 'ui-avatar',

  props: {
    user: {
      type: Object,
      default: null,
    },
    // size: {
    //   type: String,
    //   default: '32',
    // },
  },
  computed: {
    avatarSrc() {
      // return this.user.
      const userKey =
        this.user.first_name || this.user.last_name
          ? this.user.first_name[0] + this.user.last_name[0]
          : this.user.email;

      // return `https://avatars.dicebear.com/v2/gridy/${userKey}.svg?options[colorful]=1&options[m]=15`;
      // return `https://avatars.dicebear.com/v2/identicon/${userKey}.svg?options[colorLevel]=600`;
      return `https://avatars.dicebear.com/v2/initials/${userKey}.svg?options[backgroundColorLevel]=400`;
      // return `https://avatars.dicebear.com/v2/jdenticon/${userKey}.svg?options[colorLevel]=300`;
      // return `https://avatars.dicebear.com/v2/human/${userKey}.svg?options[colorLevel]=300&options[m]=15`;
    },

    // imageClass() {
    //   return `is-${this.size}x${this.size}`;
    // },
  },
};
</script>

<style lang="scss">
.ui-avatar {
  img {
    background: #fff;
    box-shadow: 0 0 0 1px rgba(#000, 0.2);
  }
  .navbar.is-main & {
    height: 34px;
    width: 34px;
    margin: -10px 10px -10px 0;

    img {
      box-shadow: 0 0 0 1px rgba(#000, 0.1);
      max-height: inherit;
      max-width: inherit;
    }
  }
}
</style>
